import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

/**
 * Component wrapping the editor to apply styling overrides
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EditorDisplayWrapper = styled.div<{
	isHidden: boolean;
	isEditorActionBarRendered?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	overflowY: ({ isEditorActionBarRendered }) => (isEditorActionBarRendered ? 'hidden' : null),
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"[data-testid='ak-editor-main-toolbar'] > div[role='toolbar']": {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		marginLeft: (props) =>
			props?.isEditorActionBarRendered ? token('space.300') : token('space.0'),
	},
	/* hide the editor when the page is being previewed */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	display: (props) => (props.isHidden ? 'none' : 'unset'),
	/* CEMS-3103 - fix margin top being overridden to 0 by wiki-content class */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	[`.fabric-editor-indentation-mark > h1, .fabric-editor-indentation-mark.fabric-editor-block-mark[data-level="1"]:first-of-type > h1:first-child`]:
		{
			marginTop: token('space.500'), // Originally h700().marginTop
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'.fabric-editor-indentation-mark > h2:first-child': {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space -- Grandfathered in as part of USS-50, these actually may break performance w/ Compiled, Ignored via go/DSP-18766
		marginTop: '28px', // Originally h600().marginTop
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'.fabric-editor-indentation-mark > h3:first-child': {
		marginTop: token('space.300'), // Originally h500().marginTop
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'.fabric-editor-indentation-mark > h4:first-child': {
		marginTop: token('space.200'), // Originally h400().marginTop
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'.fabric-editor-indentation-mark > h5:first-child': {
		marginTop: token('space.250'), // Originally h300().marginTop
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'.fabric-editor-indentation-mark > h6:first-child': {
		marginTop: token('space.200'), // Originally h100().marginTop
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.ak-ul li > ul': {
		marginTop: token('space.050'),
	},
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'&:has([data-editor-primary-toolbar-hidden="true"]) [data-testid="status-indicator"]': {
		top: 0,
	},
});
